import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { decodeToken } from './authUtils';
import { handleLogout } from '../store/auth/AuthSlice';

export const useAuthWatcher = () => {
  const dispatch = useDispatch();

  const checkTokenValidity = () => {
    const token = Cookies.get('token');
    const decoded = token ? decodeToken(token) : null;

    if (!token || (decoded?.exp && Date.now() > decoded.exp * 1000)) {
      dispatch(handleLogout());
    }
  };

  useEffect(() => {
    const interval = setInterval(checkTokenValidity, 30000); 
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        checkTokenValidity();
      }
    });

    checkTokenValidity(); 

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', checkTokenValidity);
    };
  }, [dispatch]);
};
